import React from 'react';
import NodePersonalizado from './NodePersonalizado';

import "./style.scss"

export default function NodeSetor({ data, id, type, ...rest }) {
    return <NodePersonalizado key={id} id={id} label={`Ir para setor`} data={data} type={type} handles={1} {...rest} />
}